import {
  UpdateCompanySettingsVersionDocument,
  UpdateCompanySettingsVersionMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateAttendanceCompanySettingsVersion = () => {
  const [updateCompanySettingsVersion, { loading }] = useMutation(
    UpdateCompanySettingsVersionDocument,
    {
      extractorFn: (data) => data.attendanceMutations.updateAttendanceCompanySettingsVersion,
    }
  )

  const updateSettingsVersion = (variables: UpdateCompanySettingsVersionMutationVariables) => {
    return updateCompanySettingsVersion({ variables })
  }

  return {
    loading,
    updateSettingsVersion,
  }
}
